import React, { Component } from 'react';

import { PieChart, Pie, Sector, Cell, Label } from 'recharts';

import { AccentColor } from 'helpers/AccentColorHelper';

import Card from '@material-ui/core/Card';
import { CardText } from 'material-ui/Card';
import classNames from 'classnames';

const style = {
  transactionCard: {
    color: '#424242 !important',
    fontFamily: '"Circular", sans-serif !important',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '8px',
    boxShadow: '1px 4px 15px rgba(0, 0, 0, 0.15)',
    padding: '15px',
  },
};

function CustomLabel({ viewBox, headerValue, subHeaderValue }) {
  const { cx, cy } = viewBox;
  return (
    <g>
      <text
        x={cx}
        y={cy - 20}
        dy={25}
        textAnchor="middle"
        fill={'#4e4e4e'}
        style={{ fontSize: '30px', fontFamily: 'Circular-Bold' }}
      >
        {headerValue}
      </text>
      <text
        x={cx}
        y={cy}
        dy={15}
        textAnchor="middle"
        fill={'#4e4e4e'}
        style={{ fontSize: '10px', fontFamily: 'Circular-Bold' }}
      >
        {subHeaderValue}
      </text>
    </g>
  );
}

export class PieChartWithMiddleLabel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: null,
      activeClickIndex: null,
    };
  }

  onPieEnter = (data, index) => {
    this.setState({
      activeIndex: index,
    });
  };

  onPieLeave = (data, index) => {
    this.setState({
      activeIndex: null,
    });
  };

  onClickAction = ({ payload }, index) => {
    if (this.state.activeClickIndex !== null) {
      this.setState({
        activeClickIndex: null,
        activeIndex: null,
      });

      this.props.onClickAction(payload.name);
      return;
    }

    this.setState({
      activeClickIndex: index,
      activeIndex: index,
    });

    this.props.onClickAction(payload.name);
  };

  renderActiveShape = props => {
    const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, payload } = props;
    const fill = this.props.colorMapper[`${payload.name.replace(/\s+/g, '_')}`];

    return (
      <g>
        <text
          x={cx}
          y={cy - 20}
          dy={25}
          textAnchor="middle"
          fill={'#4e4e4e'}
          style={{ pointerEvents: 'none', fontSize: '30px', fontFamily: 'Circular-Bold' }}
        >
          {payload.value}
        </text>
        <text
          x={cx}
          y={cy}
          dy={15}
          textAnchor="middle"
          fill={'#4e4e4e'}
          style={{ pointerEvents: 'none', fontSize: '10px', fontFamily: 'Circular-Bold' }}
        >
          {payload.name.replace('_', ' ').replace('_', ' ')}
        </text>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={AccentColor()}
          style={{ cursor: 'pointer' }}
        />
        <Sector
          cx={cx}
          cy={cy}
          startAngle={startAngle}
          endAngle={endAngle}
          innerRadius={outerRadius + 6}
          outerRadius={outerRadius + 10}
          fill={fill}
          style={{ cursor: 'pointer' }}
        />
      </g>
    );
  };
  render() {
    const data = this.props.pieChartValues || [];
    const activeSelection =
      this.state.activeClickIndex === null ? this.state.activeIndex : this.state.activeClickIndex;

    return (
      <PieChart width={180} height={180} style={{ margin: 'auto' }}>
        <Pie
          activeIndex={activeSelection}
          activeShape={this.renderActiveShape}
          data={data}
          dataKey="value"
          nameKey="name"
          innerRadius={55}
          outerRadius={75}
          fill="#8884d8"
          onMouseEnter={this.onPieEnter}
          onMouseLeave={this.onPieLeave}
          paddingAngle={0}
          onClick={this.onClickAction}
        >
          {activeSelection === null && (
            <Label
              position="center"
              content={
                <CustomLabel
                  headerValue={this.props.inactiveSubheader}
                  subHeaderValue={this.props.inactiveHeader}
                />
              }
            />
          )}

          {data.map((entry, index) => {
            return (
              <Cell
                fill={this.props.colorMapper[data[index].name.toLowerCase().replace(/\s+/g, '_')]}
                key={index}
              />
            );
          })}
        </Pie>
      </PieChart>
    );
  }
}

export class DashboardKPI extends Component {
  render() {
    return (
      <Card
        style={{
          maxWidth: '250px',
          margin: 'auto',
          cursor: 'pointer',
          display: 'block',
          border:
            this.props.filterValue === this.props.highlightValue
              ? `2px solid ${AccentColor()}`
              : 'none',
        }}
        onClick={() => this.props.onClickAction(this.props.headerValue)}
      >
        <div
          style={{
            backgroundColor: AccentColor(),
            height: '55px',
            width: '55px',
            float: 'left',
          }}
        >
          {this.props.icon}
        </div>
        <div style={{ float: 'right', width: 'calc(100% - 55px)' }}>
          <div style={{ padding: '0px 0' }}>
            <p
              style={{
                fontSize: '30px',
                margin: '0 0 -6px 0',
                textAlign: 'center',
                fontFamily: 'Circular-Black',
              }}
            >
              {this.props.headerValue}
            </p>
            <p
              style={{
                margin: '0',
                textAlign: 'center',
                fontSize: '10px',
                fontFamily: 'Circular-Bold',
              }}
            >
              {this.props.subHeaderValue}
            </p>
          </div>
        </div>
      </Card>
    );
  }
}

export const DashboardOverviewTile = ({ overviewHighlight, itemDescription }) => (
  <div
    className="col-sm-3 col-xs-6"
    style={{ textAlign: 'center', margin: '10px 0', padding: '0 15px' }}
  >
    <Card
      style={{ ...style.transactionCard, padding: 0 }}
      className={classNames('highlight-on-hover')}
    >
      <CardText expandable={true} style={{ padding: '15px', cursor: 'pointer' }}>
        <h3 style={{ margin: 0, fontSize: '30px' }}>{overviewHighlight}</h3>
        <hr
          style={{
            maxWidth: '35px',
            margin: '12px auto',
            borderTop: `3px solid ${AccentColor()}`,
          }}
        />
        <p style={{ fontFamily: 'Circular', margin: 0 }}>{itemDescription}</p>
      </CardText>
    </Card>
  </div>
);
